import React from 'react';
import { useSelector } from 'react-redux';

import useResourceQuery from 'dpl/shared/fetching/hooks/useResourceQuery';
import { faqsResourceDefinition } from 'dpl/breeder_search_results/utils/queryDefinitions';
import FAQItem from 'dpl/breeder_search_results/components/FAQItem';

export default function FrequentlyAskedQuestions() {
  const { breedId, citySlug } = useSelector(({ server }) => server);
  const { value: faqData } = useResourceQuery(
    faqsResourceDefinition(breedId, citySlug)
  );

  if (faqData.data.length === 0) {
    return null;
  }

  return (
    <div className="BreederSearchResultsFrequentlyAskedQuestions">
      <p className="mb4 mb6-lg f4-sm f5-lg b fw-medium-ns">
        Frequently Asked Questions
      </p>
      <ul className="row">
        {faqData.data.map((faq, i) => (
          <li key={i} className="col-12 col-md-6">
            <FAQItem question={faq.question} answer={faq.answer} />
          </li>
        ))}
      </ul>
    </div>
  );
}
